module.exports = __webpack_public_path__ + "img/banner1.31816998.png";